<template>
  <div class="group-setup" v-if="visible && uuid">
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">Principal Coordinator CPE Review</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>

      <v-row class="pa-5" v-if="role === 'PRINCIPAL_COORDINATOR_CPE' && !editMode">
        <v-col cols="11">
          <p style="white-space: pre-wrap;">{{ comment }}</p>
        </v-col>
        <v-col cols="1" class="d-flex align-start justify-center pt-3">
          <v-btn icon color="orange" @click="editMode = true" title="Edit Comment">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="pa-5" v-if="role === 'PRINCIPAL_COORDINATOR_CPE' && editMode">
        <v-col cols="12">
          <v-textarea v-model="comment" outlined dense label="Add your comment for CPE review"
            :readonly="false"></v-textarea>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn large color="green" class="white--text" depressed :disabled="loading || !comment" block
            @click="saveComment()">Save Comment</v-btn>
        </v-col>
      </v-row>

      <v-row class="pa-5" v-if="role === 'CLUBS_PERFORMANCE_EVALUATION'">
        <v-col cols="12">
          <p style="white-space: pre-wrap;">{{ data.principal_cpe_comment }}</p>
        </v-col>
      </v-row>

      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "PrincipalCpeReview",
  props: ["data", "uuid"],
  components: {},

  data: () => ({
    role: localStorage.getItem("role") || null,
    loading: false,
    comment: null,
    errors: null,
    editMode: false,
  }),

  mounted() {
    this.loadComment();
  },

  watch: {
    data: {
      handler() {
        this.loadComment();
      },
      deep: true,
    },
  },

  computed: {
    visible() {
      if (!this.data || !this.data.status) return false;
      const allowedStatuses = ['REGION_REVIEWED', 'SUBMITTED'];
      const allowedRoles = ['PRINCIPAL_COORDINATOR_CPE', 'CLUBS_PERFORMANCE_EVALUATION'];
      return allowedStatuses.includes(this.data.status) && allowedRoles.includes(this.role);
    },
  },

  methods: {
    loadComment() {
      if (this.data && this.data.principal_cpe_comment) {
        this.comment = this.data.principal_cpe_comment;
        this.editMode = false;
      } else {
        this.comment = null;
        this.editMode = true;
      }
    },

    saveComment() {
      this.loading = true;
      ProjectService.updatePrincipalCpeComment(this.uuid, {
        principal_cpe_comment: this.comment,
      })
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$emit("reload");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error?.response?.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },
};
</script>
